package com.kinoshazam.uiKit.webView
/** Shared Venom hide CSS + bridge script (v16) for web / Android / desktop. */
object PlayerEmbedScripts {
    const val VENOM_HIDE_CSS = """
html, body {
  background: #000 !important;
  overflow: hidden !important;
}
html.kinoshka-hide-venom,
html.kinoshka-hide-venom body {
  background: #000 !important;
  overflow: hidden !important;
}
#player video,
#player canvas,
#player img {
  pointer-events: none !important;
}
/* Promote video onto a composited layer (Android WebView: avoid SurfaceView black frame). */
#player video {
  -webkit-transform: translateZ(0) !important;
  transform: translateZ(0) !important;
  opacity: 1 !important;
  visibility: visible !important;
}
#player video::-webkit-media-controls {
  display: none !important;
}
#player [class*="controls_"],
#player [class*="bottom_"],
#player [class*="top_"],
#player [class*="menu_"],
#player [class*="overlay_"],
#player [class*="panel_"],
#player [class*="gradient_"],
#player [class*="center_"],
#player [class*="nearCenter_"],
#player [class*="mobileOverlay_"],
#player [class*="timeline_"],
#player [class*="spacer_"],
#player [class*="title_"],
#player [class*="time_"],
#player [class*="button_"],
#player [class*="lower_"],
#player [class*="innerIndent_"],
#player [class*="bottomUp_"],
#player [class*="negativeLeft_"],
#player [class*="muted_"],
#player [class*="tv_"],
#player [class*="up_"],
#player [class*="share"],
#player [class*="Settings"],
#player [class*="settings"],
#player [class*="playlist"],
#player [class*="context"],
#player [class*="tooltip"],
#player [class*="loading"],
#player [class*="Loading"],
#player [class*="spinner"],
#player [class*="Spinner"],
#player [class*="waiting"],
#player [class*="Waiting"],
#player [class*="buffer"],
#player [class*="Buffer"],
#player [class*="preloader"],
#player [class*="Preloader"],
#player [class*="circular"],
#player [class*="Circular"],
#player [class*="volume"],
#player [class*="fullscreen"],
#player [class*="pip"],
#player [class*="seek"],
#player [class*="progress"],
#player [class*="quality"],
#player [class*="subtitle"],
#player [class*="cc_"],
#player button,
#player input,
#player select,
#player textarea,
#player [role="button"],
#player [role="slider"],
#player [role="menu"],
#player [role="menuitem"],
#player [role="dialog"],
#player [role="toolbar"],
#player a[href] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  width: 0 !important;
  height: 0 !important;
  max-width: 0 !important;
  max-height: 0 !important;
  overflow: hidden !important;
}
#player [class*="Control"],
#player [class*="Hud"],
#player [class*="Toolbar"],
#player [class*="toolbar"],
[class*="controls_"],
[class*="Controls"],
[class*="controlBar"],
[class*="ControlBar"],
[class*="bottomBar"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
"""

    const val BRIDGE_SCRIPT_BODY = """
(function () {
  if (window.__kinoshka && window.__kinoshka.bridgeVersion >= 28 &&
      typeof window.__kinoshka.setPlaying === 'function') return;
  try {
    if (window.__ksHideTimer) clearInterval(window.__ksHideTimer);
    if (window.__ksBindTimer) clearInterval(window.__ksBindTimer);
    if (window.__ksWatchTimer) clearInterval(window.__ksWatchTimer);
  } catch (eClr) {}
  window.__kinoshkaBridge = 1;

  // Undo Object.prototype.ctrl pollution from older kinoshka early-patch builds.
  try {
    if (Object.prototype.__ksCtrlTrap) {
      delete Object.prototype.ctrl;
      delete Object.prototype.__ksCtrlTrap;
    }
  } catch (e) {}
  try {
    var early = document.getElementById('kinoshka-early');
    if (early && early.parentNode) early.parentNode.removeChild(early);
  } catch (e) {}

  function hideVenomChrome() {
    try {
      document.documentElement && document.documentElement.classList.add('kinoshka-hide-venom');
      document.body && document.body.classList.add('kinoshka-hide-venom');
    } catch (e) {}
    try {
      var style = document.getElementById('kinoshka-hide-venom');
      if (!style) {
        style = document.createElement('style');
        style.id = 'kinoshka-hide-venom';
        (document.head || document.documentElement || document.body).appendChild(style);
      }
      // Keep textContent in sync if an older inject left a stub.
      if (!style.__ksFull) {
        style.__ksFull = 1;
        style.textContent = style.textContent || '';
      }
    } catch (e) {}
    try {
      document.documentElement.style.background = '#000';
      if (document.body) document.body.style.background = '#000';
    } catch (e) {}
    try {
      var nodes = document.querySelectorAll('video');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].controls = false;
        try { nodes[i].removeAttribute('controls'); } catch (e2) {}
      }
    } catch (e) {}
    try {
      if (!window.__ksVideoUnhidden) unhideVideoTree();
    } catch (e) {}
  }

  function unhideVideoTree() {
    var medias = document.querySelectorAll('#player video');
    if (!medias || !medias.length) medias = document.querySelectorAll('video');
    if (!medias || !medias.length) return;
    for (var i = 0; i < medias.length; i++) {
      var el = medias[i];
      try {
        if (el.getAttribute && el.getAttribute('data-ks-split') === '1') continue;
      } catch (e0) {}
      try {
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('object-fit', 'contain', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      } catch (e1) {}
      var p = el.parentElement;
      while (p && p !== document.body && p !== document.documentElement) {
        try {
          p.style.setProperty('display', 'block', 'important');
          p.style.setProperty('visibility', 'visible', 'important');
          p.style.setProperty('opacity', '1', 'important');
          p.style.setProperty('width', '100%', 'important');
          p.style.setProperty('height', '100%', 'important');
          p.style.setProperty('max-width', 'none', 'important');
          p.style.setProperty('max-height', 'none', 'important');
          p.style.setProperty('overflow', 'visible', 'important');
          p.style.setProperty('pointer-events', 'none', 'important');
        } catch (e2) {}
        if (p.id === 'player') break;
        p = p.parentElement;
      }
    }
    try {
      var v = document.querySelector('#player video') || document.querySelector('video');
      try {
        var hooked = videoEl();
        if (hooked && (!v || (hooked.videoWidth || 0) > (v.videoWidth || 0))) v = hooked;
      } catch (eV) {}
      if (v && v.videoWidth > 0) window.__ksVideoUnhidden = 1;
    } catch (e3) {}
  }

  hideVenomChrome();
  window.__ksHideTimer = setInterval(hideVenomChrome, 800);

  function post(data) {
    try { parent.postMessage(Object.assign({ source: 'kinoshka' }, data), '*'); } catch (e) {}
  }

  function forceTime(v, t) {
    if (!v) return;
    // Assign on the element so hls.js / Venom interceptors run.
    // Prototype setter bypass skips HLS and leaves a black frame.
    try { v.currentTime = t; } catch (e) {}
  }

  function resumeAfterSeek(v, generation, wasPlaying) {
    if (!v || !wasPlaying) return;
    var finished = false;
    var restart = function () {
      if (finished || generation !== window.__ksSeekGeneration) return;
      finished = true;
      try { v.removeEventListener('seeked', restart); } catch (e0) {}
      try {
        var p = window.__ksRawPlayer || findApp();
        var hls = p && p.source && p.source.hls;
        if (hls && typeof hls.startLoad === 'function') hls.startLoad();
      } catch (e1) {}
      // Venom/HLS can remain audio-only after a seek. Restart the media pipeline
      // once the seek has completed; this is the same pause/play that restores
      // the picture manually, but runs at the correct media lifecycle point.
      try { v.pause(); } catch (e2) {}
      try {
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } catch (e3) {}
      try { unhideVideoTree(); } catch (e4) {}
    };
    try { v.addEventListener('seeked', restart, { once: true }); } catch (e5) {}
    // Some broken HLS manifests never dispatch seeked after a discontinuity.
    setTimeout(restart, 1800);
  }

  function applySeek(app, seconds) {
    var t = Number(seconds);
    if (!isFinite(t) || t < 0) return false;
    var v = videoEl();
    if (!v) {
      try { v = app && app.videoElement; } catch (e0) { v = null; }
    }
    if (!v) return false;
    try {
      if (isFinite(v.currentTime) && Math.abs(v.currentTime - t) < 0.25) {
        return true;
      }
    } catch (e2) {}
    var wasPlaying = false;
    try { wasPlaying = !v.paused && !v.ended; } catch (e3) {}
    window.__ksSeekGeneration = (window.__ksSeekGeneration || 0) + 1;
    var generation = window.__ksSeekGeneration;
    resumeAfterSeek(v, generation, wasPlaying);
    var seekDelivered = false;
    try {
      if (app && typeof app.seek === 'function') {
        // This is exactly how Venom's own timeline seeks: a 0..1 fraction.
        if (app.source && isFinite(v.duration) && v.duration > 0) app.seek(t / v.duration);
        else app.seek(t);
        seekDelivered = true;
      }
    } catch (eSeek) {}
    if (!seekDelivered) forceTime(v, t);
    return true;
  }

  function findApp() {
    try {
      if (window.app && (window.app.play || window.app.playPause || window.app.videoElement || window.app._settings)) return window.app;
    } catch (e) {}
    try {
      if (window.__kinoshka && window.__kinoshka.app) return window.__kinoshka.app;
    } catch (e) {}
    return null;
  }

  function isSettingsObj(o) {
    try {
      return !!(o && o.ctrl && o.ctrl.ls);
    } catch (e) { return false; }
  }

  function isFullSettingsObj(o) {
    try {
      return !!(o && typeof o.selectQuality === 'function' && o.ctrl && o.ctrl.ls);
    } catch (e) { return false; }
  }

  function captureFromThis() {
    try {
      var self = this;
      // Prefer real Ai player (has .source); facade from VenomPlayer.make does not.
      if (self && self.source && (self.cp || self.videoElement || self.video)) {
        window.__ksRawPlayer = self;
        try {
          if (self.cp && isSettingsObj(self.cp.settings)) window.__ksSettings = self.cp.settings;
        } catch (e0) {}
        return true;
      }
      if (self && self.cp && isSettingsObj(self.cp.settings)) {
        window.__ksSettings = self.cp.settings;
        window.__ksRawPlayer = self;
        return true;
      }
    } catch (e) {}
    return false;
  }

  var CAPTURE_EVS = ['ready', 'timeupdate', 'play', 'playing', 'loadedmetadata',
    'durationchange', 'progress', 'canplay'];

  function hookPlayerCapture(facade) {
    if (!facade || typeof facade.on !== 'function') return;
    if (!facade.__ksCaptureHooked) {
      facade.__ksCaptureHooked = 1;
      for (var i = 0; i < CAPTURE_EVS.length; i++) {
        try { facade.on(CAPTURE_EVS[i], captureFromThis); } catch (e) {}
      }
    }
    try {
      var cur = facade.onRenew;
      if (!cur || !cur.__ks) {
        var prev = cur;
        var wrapped = function () {
          try { if (typeof prev === 'function') prev.apply(this, arguments); } catch (e) {}
          try {
            facade.__ksCaptureHooked = 0;
            hookPlayerCapture(facade);
          } catch (e) {}
        };
        wrapped.__ks = 1;
        facade.onRenew = wrapped;
      }
    } catch (e) {}
  }

  function findSettings() {
    try {
      if (isSettingsObj(window.__ksSettings)) {
        try { hookSoundCapture(window.__ksSettings, window.__ksRawPlayer || findApp()); } catch (e) {}
        return window.__ksSettings;
      }
    } catch (e) {}
    try {
      var raw = window.__ksRawPlayer;
      if (raw && raw.cp && isSettingsObj(raw.cp.settings)) {
        window.__ksSettings = raw.cp.settings;
        try { hookSoundCapture(window.__ksSettings, raw); } catch (e) {}
        return window.__ksSettings;
      }
    } catch (e) {}
    var app = findApp();
    try { hookPlayerCapture(app); } catch (e) {}
    try {
      if (app && app.cp && isSettingsObj(app.cp.settings)) {
        window.__ksSettings = app.cp.settings;
        try { hookSoundCapture(window.__ksSettings, app); } catch (e) {}
        return window.__ksSettings;
      }
    } catch (e) {}
    try {
      if (app && isSettingsObj(app._settings)) {
        window.__ksSettings = app._settings;
        try { hookSoundCapture(window.__ksSettings, app); } catch (e) {}
        return window.__ksSettings;
      }
    } catch (e) {}
    return null;
  }

  /** Venom facade exposes stripped `_settings`, but ctrl.ls / reactive values are shared. */
  function getCtrl() {
    try {
      if (window.__ksSettings && window.__ksSettings.ctrl && window.__ksSettings.ctrl.ls) {
        return window.__ksSettings.ctrl;
      }
    } catch (e) {}
    try {
      var app = findApp();
      var st = app && app._settings;
      if (st && st.ctrl && st.ctrl.ls) return st.ctrl;
    } catch (e) {}
    return null;
  }

  function coerceList(v) {
    if (!v) return [];
    try {
      if (Array.isArray(v)) return v.slice();
    } catch (e) {}
    try {
      if (typeof Array.from === 'function') {
        var af = Array.from(v);
        if (af && af.length) return af;
      }
    } catch (e) {}
    try {
      // Manual copy — avoid JSON.stringify (hangs on Vue reactive proxies in JavaFX WebKit).
      if (v && typeof v.length === 'number' && typeof v !== 'string') {
        var out = [];
        var n = Math.min(Number(v.length) || 0, 64);
        for (var i = 0; i < n; i++) {
          try { out.push(v[i]); } catch (e2) { break; }
        }
        return out;
      }
    } catch (e) {}
    return [];
  }

  function labelOfSound(item) {
    if (item == null || item === undefined) return null;
    if (typeof item === 'string' || typeof item === 'number') return String(item);
    try {
      return item.title || item.name || item.label || item.translation ||
        item.sound || item.lang || item.language || item.value || null;
    } catch (e) { return null; }
  }

  function rememberSoundList(list) {
    var mapped = [];
    var raw = coerceList(list);
    for (var i = 0; i < raw.length; i++) {
      var lab = labelOfSound(raw[i]);
      if (lab != null && lab !== '') mapped.push(lab);
    }
    if (mapped.length) {
      window.__ksSoundList = mapped;
      return mapped;
    }
    return [];
  }

  /** Venom fills tracks via settings.makeSound(list) / player.makeSoundtracks(list). */
  function hookSoundCapture(s, player) {
    try {
      if (s && typeof s.makeSound === 'function' && !s.__ksSoundHooked) {
        s.__ksSoundHooked = 1;
        var orig = s.makeSound.bind(s);
        s.makeSound = function (list, cb, idx) {
          try { rememberSoundList(list); } catch (e) {}
          return orig(list, cb, idx);
        };
      }
    } catch (e) {}
    try {
      if (player && typeof player.makeSoundtracks === 'function' && !player.__ksTracksHooked) {
        player.__ksTracksHooked = 1;
        var origT = player.makeSoundtracks.bind(player);
        player.makeSoundtracks = function (list, settings) {
          try { rememberSoundList(list); } catch (e) {}
          return origT(list, settings);
        };
      }
    } catch (e) {}
  }

  function readAudioListFromSource(player) {
    try {
      var src = player && player.source;
      if (!src) return [];
      // Tobaco passes studio names here (LostFilm, Cubus, …) — this is the real «озвучка».
      var names = src.audioNames || src.audio_names;
      var named = rememberSoundList(names);
      if (named.length > 1) return named;
      var list = src.audioList || src.audioAll_ || src.audioTracks || src.sounds || src.translations;
      var fromList = rememberSoundList(list);
      if (fromList.length > 1) return fromList;
      return named.length ? named : fromList;
    } catch (e) { return []; }
  }

  /** Parse studio names from embed page (tobaco: audio.names / audioNames). */
  function scrapeAudioNamesFromPage() {
    try {
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) {
        var t = scripts[i].textContent || '';
        if (t.indexOf('audio') < 0 && t.indexOf('LostFilm') < 0 && t.indexOf('Кубик') < 0) continue;
        var m = t.match(/"audio"\s*:\s*\{\s*"names"\s*:\s*(\[[^\]]{8,4000}\])/);
        if (!m) m = t.match(/audio\s*:\s*\{\s*names\s*:\s*(\[[^\]]{8,4000}\])/);
        if (!m) m = t.match(/audioNames\s*:\s*(\[[^\]]{8,4000}\])/);
        if (!m) m = t.match(/audioNames\s*=\s*(\[[^\]]{8,4000}\])/);
        if (m) {
          try {
            var parsed = (new Function('return (' + m[1] + ')'))();
            var got = rememberSoundList(parsed);
            if (got.length > 1) return got;
          } catch (e) {}
        }
      }
    } catch (e) {}
    return [];
  }

  /** Studio-name list used by our menu (NOT Venom's rus0/rus1 HLS labels). */
  function studioSoundNames() {
    try { ensureSoundListFilled(); } catch (e) {}
    if (window.__ksSoundList && window.__ksSoundList.length > 1) {
      return window.__ksSoundList.slice();
    }
    try {
      var p = findRawPlayer() || window.__ksRawPlayer || findApp();
      var fromSrc = readAudioListFromSource(p);
      if (fromSrc.length > 1) return fromSrc;
    } catch (e2) {}
    var fromPage = scrapeAudioNamesFromPage();
    if (fromPage.length > 1) return fromPage;
    return [];
  }

  /** Real Venom Ai instance — window.app is a facade without .source. */
  function findRawPlayer() {
    try {
      if (window.__ksRawPlayer && window.__ksRawPlayer.source) return window.__ksRawPlayer;
    } catch (e) {}
    try {
      if (window.__ksRawPlayer && window.__ksRawPlayer.videoElement) return window.__ksRawPlayer;
    } catch (e2) {}
    try {
      if (window.__ksRawPlayer && window.__ksRawPlayer.cp) return window.__ksRawPlayer;
    } catch (e3) {}
    return null;
  }

  function fetchTextSync(url) {
    if (!url) return '';
    try {
      if (window.kinoshkaHost && typeof window.kinoshkaHost.fetchText === 'function') {
        var hostText = window.kinoshkaHost.fetchText(url);
        if (hostText && hostText.length > 16) return String(hostText);
      }
    } catch (e) {}
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, false);
      xhr.send(null);
      if (xhr.status >= 200 && xhr.status < 400 && xhr.responseText) return xhr.responseText;
    } catch (e2) {}
    return '';
  }

  function absUrl(base, rel) {
    try {
      if (!rel) return rel;
      if (/^https?:/i.test(rel) || rel.indexOf('blob:') === 0 || rel.indexOf('data:') === 0) return rel;
      return new URL(rel, base).href;
    } catch (e) { return rel; }
  }

  function findHlsMasterUrl() {
    try {
      if (window.__ksHlsMasterUrl && /^https?:/i.test(window.__ksHlsMasterUrl) &&
          String(window.__ksHlsMasterUrl).indexOf('127.0.0.1') < 0 &&
          !/index-a\d+\.m3u8/i.test(String(window.__ksHlsMasterUrl))) {
        return window.__ksHlsMasterUrl;
      }
    } catch (e0) {}
    try {
      var p = findRawPlayer();
      var src = p && p.source;
      if (src) {
        var opts = src._options || src.options;
        if (opts && opts.hls && String(opts.hls).indexOf('http') === 0) {
          window.__ksHlsMasterUrl = String(opts.hls);
          return window.__ksHlsMasterUrl;
        }
        if (src._url && String(src._url).indexOf('m3u8') >= 0 && String(src._url).indexOf('127.0.0.1') < 0) {
          window.__ksHlsMasterUrl = String(src._url);
          return window.__ksHlsMasterUrl;
        }
      }
    } catch (e) {}
    try {
      var html = document.documentElement && document.documentElement.innerHTML || '';
      var m = html.match(/"hls"\s*:\s*"(https:[^"]+\.m3u8[^"]*)"/);
      if (m) {
        var u = m[1].replace(/\\u0026/g, '&').replace(/\\\//g, '/');
        window.__ksHlsMasterUrl = u;
        return u;
      }
    } catch (e4) {}
    try {
      var v = videoEl();
      if (v) {
        var s = String(v.currentSrc || v.src || '');
        if (s && s.indexOf('m3u8') >= 0 && s.indexOf('blob:') !== 0 &&
            s.indexOf('127.0.0.1') < 0 && !/index-a\d+\.m3u8/i.test(s)) {
          window.__ksHlsMasterUrl = s;
          return s;
        }
      }
    } catch (e2) {}
    return null;
  }

  /**
   * Rewrite HLS master so only studio [audioIdx] remains.
   * Needed for JavaFX/WebKit native HLS where hls.js is absent and audioTracks are inert.
   */
  function rewriteMasterForAudioIndex(masterText, masterUrl, audioIdx) {
    if (!masterText || audioIdx < 0) return null;
    var lines = String(masterText).replace(/\r/g, '').split('\n');
    var audioRe = /^#EXT-X-MEDIA:TYPE=AUDIO,(.+)$/i;
    var streamRe = /^#EXT-X-STREAM-INF:(.+)$/i;
    var audios = [];
    for (var i = 0; i < lines.length; i++) {
      var am = lines[i].match(audioRe);
      if (!am) continue;
      var attrs = am[1];
      var g = (attrs.match(/GROUP-ID="([^"]+)"/i) || [])[1] || '';
      var name = (attrs.match(/NAME="([^"]+)"/i) || [])[1] || '';
      var uri = (attrs.match(/URI="([^"]+)"/i) || [])[1] || '';
      audios.push({ lineIdx: i, groupId: g, name: name, uri: uri, raw: lines[i], attrs: attrs });
    }
    if (!audios.length) return null;

    // Prefer primary group (first non-failover), preserve playlist order.
    var primaryGroup = audios[0].groupId;
    for (var a = 0; a < audios.length; a++) {
      if (!/failover/i.test(audios[a].groupId)) { primaryGroup = audios[a].groupId; break; }
    }
    var primary = [];
    var seenName = {};
    for (var b = 0; b < audios.length; b++) {
      if (audios[b].groupId !== primaryGroup) continue;
      if (seenName[audios[b].name]) continue;
      seenName[audios[b].name] = 1;
      primary.push(audios[b]);
    }
    if (!primary.length) primary = audios.slice(0, 1);
    if (audioIdx >= primary.length) return null;
    var selected = primary[audioIdx];
    var selectedName = selected.name;

    // Keep ONLY the primary audio group (drop failover) — simpler for WebKit.
    var keepGroup = selected.groupId;

    var out = [];
    var skipNextUrl = false;
    for (var li = 0; li < lines.length; li++) {
      var line = lines[li];
      if (!line && line !== '') { out.push(line); continue; }
      if (skipNextUrl) {
        skipNextUrl = false;
        if (line && line.charAt(0) !== '#') continue;
      }
      var am2 = line.match(audioRe);
      if (am2) {
        var g2 = (am2[1].match(/GROUP-ID="([^"]+)"/i) || [])[1] || '';
        var n2 = (am2[1].match(/NAME="([^"]+)"/i) || [])[1] || '';
        if (g2 !== keepGroup || n2 !== selectedName) continue;
        var uri2 = (am2[1].match(/URI="([^"]+)"/i) || [])[1] || '';
        var abs = absUrl(masterUrl, uri2);
        var rebuilt = '#EXT-X-MEDIA:TYPE=AUDIO,GROUP-ID="' + g2 + '",NAME="' + n2 +
          '",DEFAULT=YES,AUTOSELECT=YES';
        var lang = (am2[1].match(/LANGUAGE="([^"]+)"/i) || [])[1];
        if (lang) rebuilt += ',LANGUAGE="' + lang + '"';
        rebuilt += ',URI="' + abs + '"';
        out.push(rebuilt);
        continue;
      }
      var sm = line.match(streamRe);
      if (sm) {
        var ag = (sm[1].match(/AUDIO="([^"]+)"/i) || [])[1] || '';
        if (ag && ag !== keepGroup) {
          skipNextUrl = true;
          continue;
        }
        out.push(line);
        if (li + 1 < lines.length && lines[li + 1] && lines[li + 1].charAt(0) !== '#') {
          out.push(absUrl(masterUrl, lines[li + 1]));
          skipNextUrl = true;
        }
        continue;
      }
      out.push(line);
    }
    return out.join('\n');
  }

  function dismissPlayerLoading() {
    try {
      var p = findRawPlayer();
      if (p && p.ui && p.ui.loading && typeof p.ui.loading.hide === 'function') p.ui.loading.hide();
    } catch (e) {}
    try {
      var sels = [
        '#player [class*="loading"]',
        '#player [class*="Loading"]',
        '#player [class*="spinner"]',
        '#player [class*="Spinner"]',
        '#player [class*="waiting"]',
        '#player [class*="buffer"]',
        '#player [class*="preloader"]'
      ];
      for (var s = 0; s < sels.length; s++) {
        var nodes = document.querySelectorAll(sels[s]);
        for (var i = 0; i < nodes.length; i++) {
          try {
            nodes[i].style.setProperty('display', 'none', 'important');
            nodes[i].style.setProperty('opacity', '0', 'important');
            nodes[i].style.setProperty('visibility', 'hidden', 'important');
          } catch (e2) {}
        }
      }
    } catch (e3) {}
  }

  /** Undo broken data:/blob:/file masters and audio-only playlists from older builds. */
  function repairBrokenMediaSrc() {
    try {
      var v = videoEl();
      if (!v) return false;
      var cur = String(v.currentSrc || v.src || '');
      // MSE / hls.js uses blob: or empty src — do not treat that as broken.
      try { if (v.srcObject) return false; } catch (eSo) {}
      if (/^blob:/i.test(cur)) return false;
      try {
        var rp = window.__ksRawPlayer || findRawPlayer();
        if (rp && rp.source && (rp.source.hls || rp.source.dash)) return false;
      } catch (eMs) {}
      if (!cur) return false;
      // Intentional desktop rewritten master lives on 127.0.0.1/audio.m3u8 — do not undo it.
      var intentionalLocal = cur.indexOf('127.0.0.1') >= 0 && cur.indexOf('/audio.m3u8') >= 0;
      var broken = /^(data:|file:)/i.test(cur) || /index-a\d+\.m3u8/i.test(cur);
      if (!broken) {
        if (cur.indexOf('m3u8') >= 0 && cur.indexOf('127.0.0.1') < 0) window.__ksHlsMasterUrl = cur;
        return false;
      }
      if (intentionalLocal) return false;
      var orig = resolveCdnMasterUrl() || window.__ksHlsMasterUrl || findHlsMasterUrl();
      if (!orig || /^(data:|blob:|file:)/i.test(orig) || /index-a\d+\.m3u8/i.test(String(orig))) {
        try {
          var html = document.documentElement && document.documentElement.innerHTML || '';
          var m = html.match(/"hls"\s*:\s*"(https:[^"]+\.m3u8[^"]*)"/);
          if (m) orig = m[1].replace(/\\u0026/g, '&').replace(/\\\//g, '/');
        } catch (eSc) {}
      }
      if (!orig || String(orig).indexOf('http') !== 0) return false;
      window.__ksHlsMasterUrl = orig;
      var t = 0;
      try { t = v.currentTime || 0; } catch (eT) {}
      var wasPaused = true;
      try { wasPaused = !!v.paused; } catch (eP) {}
      try { v.muted = false; } catch (eM) {}
      v.src = orig;
      try { v.load(); } catch (eL) {}
      var resume = function () {
        try { if (t > 0.5 && isFinite(t)) forceTime(v, t); } catch (e1) {}
        if (!wasPaused) {
          try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e2) {}
        }
        dismissPlayerLoading();
      };
      try { v.addEventListener('loadedmetadata', function onM() {
        try { v.removeEventListener('loadedmetadata', onM); } catch (e3) {}
        resume();
      }); } catch (e4) { setTimeout(resume, 300); }
      setTimeout(resume, 600);
      setTimeout(dismissPlayerLoading, 200);
      setTimeout(dismissPlayerLoading, 1000);
      return true;
    } catch (e) { return false; }
  }

  function persistTrackPreference(name, idx) {
    try {
      if (name) localStorage.setItem('player.track', String(name));
    } catch (e) {}
  }

  /** Remove broken split-audio leftovers (black video / only sound). */
  function cleanupSplitAudioArtifacts() {
    try { window.__ksSplitMode = 0; } catch (e) {}
    try {
      var a = window.__ksSplitAudio;
      if (a) {
        try { a.pause(); } catch (e1) {}
        try { a.removeAttribute('src'); a.load(); } catch (e2) {}
        try { if (a.parentNode) a.parentNode.removeChild(a); } catch (e3) {}
      }
    } catch (e4) {}
    window.__ksSplitAudio = null;
    try {
      var ghosts = document.querySelectorAll('video[data-ks-split="1"], audio[data-ks-split="1"]');
      for (var g = 0; g < ghosts.length; g++) {
        try {
          ghosts[g].pause();
          if (ghosts[g].parentNode) ghosts[g].parentNode.removeChild(ghosts[g]);
        } catch (e5) {}
      }
    } catch (e6) {}
    try {
      var v = document.querySelector('#player video');
      if (v) {
        try { v.muted = false; } catch (e7) {}
        var src = String(v.currentSrc || v.src || '');
        // Audio-only media playlists have no picture — restore CDN master.
        // Do NOT treat localhost /audio.m3u8 (rewritten multi-variant master) as broken.
        if (/index-a\d+\.m3u8/i.test(src)) {
          var orig = window.__ksHlsMasterUrl;
          if (!orig || /127\.0\.0\.1|index-a\d+/i.test(String(orig))) {
            try {
              var html = document.documentElement && document.documentElement.innerHTML || '';
              var m = html.match(/"hls"\s*:\s*"(https:[^"]+\.m3u8[^"]*)"/);
              if (m) orig = m[1].replace(/\\u0026/g, '&').replace(/\\\//g, '/');
            } catch (e8) {}
          }
          if (orig && String(orig).indexOf('http') === 0) {
            window.__ksHlsMasterUrl = orig;
            var t = 0;
            try { t = v.currentTime || 0; } catch (e9) {}
            v.src = orig;
            try { v.load(); } catch (e10) {}
            setTimeout(function () {
              try { if (t > 0.5) forceTime(v, t); } catch (e11) {}
              try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e12) {}
              dismissPlayerLoading();
            }, 400);
          }
        }
      }
    } catch (e13) {}
  }

  function enableNativeAudioTrack(idx) {
    var v = videoEl();
    var at = v && v.audioTracks;
    if (!at || !at.length || idx < 0) return false;
    var nativePicked = [];
    var nativeSeen = {};
    for (var n = 0; n < at.length; n++) {
      var lab = String((at[n] && (at[n].label || at[n].language || at[n].id || at[n].kind)) || ('#' + n));
      if (nativeSeen[lab]) continue;
      nativeSeen[lab] = 1;
      nativePicked.push(n);
    }
    if (!nativePicked.length) {
      for (var n2 = 0; n2 < at.length; n2++) nativePicked.push(n2);
    }
    if (idx >= nativePicked.length) {
      if (idx < at.length) nativePicked = null;
      else return false;
    }
    var enableAt = nativePicked ? nativePicked[idx] : idx;
    try {
      for (var t = 0; t < at.length; t++) {
        try { if (t !== enableAt) at[t].enabled = false; } catch (eD) {}
      }
    } catch (e1) {}
    try {
      at[enableAt].enabled = true;
      return !!at[enableAt].enabled;
    } catch (e2) {
      try { at[enableAt].enabled = true; return true; } catch (e3) { return false; }
    }
  }

  function resolveCdnMasterUrl() {
    try {
      if (window.__ksHlsMasterUrl && /^https?:/i.test(window.__ksHlsMasterUrl) &&
          window.__ksHlsMasterUrl.indexOf('127.0.0.1') < 0 &&
          !/index-a\d+\.m3u8/i.test(window.__ksHlsMasterUrl)) {
        return window.__ksHlsMasterUrl;
      }
    } catch (e) {}
    function unwrapProxy(u) {
      try {
        var s = String(u || '');
        var m = s.match(/[?&]u=([^&]+)/);
        if (m) {
          var dec = decodeURIComponent(m[1]);
          if (/^https?:/i.test(dec)) return dec;
        }
      } catch (e) {}
      return u;
    }
    try {
      var html = document.documentElement && document.documentElement.innerHTML || '';
      var m = html.match(/"hls"\s*:\s*"([^"]+\.m3u8[^"]*)"/);
      if (!m) m = html.match(/"hls"\s*:\s*"([^"]+)"/);
      if (m) {
        var u = unwrapProxy(m[1].replace(/\\u0026/g, '&').replace(/\\\//g, '/'));
        if (u && String(u).indexOf('http') === 0 && String(u).indexOf('127.0.0.1') < 0) {
          window.__ksHlsMasterUrl = u;
          return u;
        }
      }
    } catch (e2) {}
    try {
      var p = findRawPlayer();
      var src = p && p.source;
      var opts = src && (src._options || src.options);
      if (opts && opts.hls) {
        var hu = unwrapProxy(opts.hls);
        if (hu && String(hu).indexOf('http') === 0 && String(hu).indexOf('127.0.0.1') < 0) {
          window.__ksHlsMasterUrl = String(hu);
          return window.__ksHlsMasterUrl;
        }
      }
    } catch (e3) {}
    return null;
  }

  /**
   * Desktop path: rewrite CDN master to a single audio track and load it from
   * same-origin http://127.0.0.1/audio.m3u8 (page itself is proxied on localhost).
   */
  function switchViaRewrittenMaster(idx) {
    if (idx < 0) return false;
    if (!(window.kinoshkaHost && typeof window.kinoshkaHost.serveHlsMaster === 'function')) return false;
    var masterUrl = resolveCdnMasterUrl();
    if (!masterUrl) return false;
    var text = fetchTextSync(masterUrl);
    if (!text || text.indexOf('#EXTM3U') < 0) return false;
    var rewritten = rewriteMasterForAudioIndex(text, masterUrl, idx);
    if (!rewritten) return false;
    var served = window.kinoshkaHost.serveHlsMaster(rewritten);
    if (!served) return false;

    var v = videoEl();
    if (!v) return false;
    var t = 0;
    var wasPaused = true;
    try { t = v.currentTime || 0; } catch (e) {}
    try { wasPaused = !!v.paused; } catch (e2) {}
    try { v.muted = false; } catch (e3) {}

    var settled = false;
    var resume = function () {
      if (settled) return;
      settled = true;
      try { if (t > 0.5 && isFinite(t)) forceTime(v, t); } catch (e4) {}
      if (!wasPaused) {
        try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e5) {}
      }
      dismissPlayerLoading();
    };
    try {
      v.addEventListener('loadedmetadata', function onM() {
        try { v.removeEventListener('loadedmetadata', onM); } catch (e6) {}
        resume();
      });
    } catch (e7) {}
    try {
      v.addEventListener('playing', function onP() {
        try { v.removeEventListener('playing', onP); } catch (e8) {}
        dismissPlayerLoading();
      });
    } catch (e9) {}
    v.src = String(served);
    try {
      v.style.setProperty('opacity', '1', 'important');
      v.style.setProperty('visibility', 'visible', 'important');
      v.style.setProperty('display', 'block', 'important');
      v.style.setProperty('width', '100%', 'important');
      v.style.setProperty('height', '100%', 'important');
      v.style.setProperty('object-fit', 'contain', 'important');
      v.muted = false;
    } catch (eVis) {}
    try { v.load(); } catch (e10) {}
    setTimeout(resume, 700);
    setTimeout(dismissPlayerLoading, 300);
    setTimeout(dismissPlayerLoading, 1200);
    // If rewrite failed to play, roll back to CDN master.
    setTimeout(function () {
      try {
        if (!settled && v.readyState < 2) {
          var orig = resolveCdnMasterUrl();
          if (orig) {
            v.src = orig;
            v.load();
            setTimeout(function () {
              try { if (t > 0.5) forceTime(v, t); } catch (e11) {}
              try { var pr2 = v.play(); if (pr2 && pr2.catch) pr2.catch(function () {}); } catch (e12) {}
              dismissPlayerLoading();
            }, 300);
          }
          dismissPlayerLoading();
        }
      } catch (e13) { dismissPlayerLoading(); }
    }, 5000);
    return true;
  }

  function switchAudioByIndex(idx) {
    if (idx < 0) return false;
    try { cleanupSplitAudioArtifacts(); } catch (e0) {}
    try { repairBrokenMediaSrc(); } catch (e1) {}
    var p = null;
    try { p = findRawPlayer() || window.__ksRawPlayer || findApp(); } catch (e) {}

    // hls.js
    try {
      var hls = p && p.source && p.source.hls;
      var tracks = hls && hls.audioTracks;
      if (tracks && tracks.length) {
        var groupId = null;
        try { groupId = hls.audioTrackController && hls.audioTrackController.audioGroupId; } catch (eG) {}
        var picked = [];
        var seen = {};
        for (var i = 0; i < tracks.length; i++) {
          var tr = tracks[i];
          if (!tr) continue;
          if (groupId && tr.groupId && tr.groupId !== groupId) continue;
          var key = String(tr.name || tr.lang || i);
          if (seen[key]) continue;
          seen[key] = 1;
          picked.push(tr);
        }
        if (!picked.length) {
          for (var j = 0; j < tracks.length; j++) picked.push(tracks[j]);
        }
        if (idx < picked.length) {
          hls.audioTrack = picked[idx].id;
          try { if (p && p.source) p.source.audio = idx; } catch (eS) {}
          dismissPlayerLoading();
          return true;
        }
      }
    } catch (e2) {}

    // DASH
    try {
      var dash = p && p.source && p.source.dash;
      if (dash && typeof dash.getTracksFor === 'function') {
        var dTracks = dash.getTracksFor('audio') || [];
        if (idx < dTracks.length && typeof dash.setCurrentTrack === 'function') {
          dash.setCurrentTrack(dTracks[idx]);
          dismissPlayerLoading();
          return true;
        }
      }
    } catch (e3) {}

    // Native AudioTrackList
    try {
      if (enableNativeAudioTrack(idx)) {
        dismissPlayerLoading();
        return true;
      }
    } catch (e4) {}

    // Desktop localhost rewritten master (same-origin via embed proxy).
    try {
      if (switchViaRewrittenMaster(idx)) return true;
    } catch (e5) {}

    try { if (p && p.source) p.source.audio = idx; } catch (e6) {}
    dismissPlayerLoading();
    return false;
  }

  function readAudioTracksFromVideo() {
    try {
      var v = videoEl();
      var tracks = v && v.audioTracks;
      if (!tracks || !tracks.length) return [];
      var out = [];
      for (var i = 0; i < tracks.length && i < 32; i++) {
        var t = tracks[i];
        var lab = (t && (t.label || t.language || t.kind)) || ('Track ' + (i + 1));
        if (lab) out.push(String(lab));
      }
      if (out.length) window.__ksSoundList = out;
      return out;
    } catch (e) { return []; }
  }

  function scrapeSoundFromDom() {
    try {
      var sels = [
        '#player [class*="sound"] [class*="item"]',
        '#player [class*="sound"] [class*="option"]',
        '#player [class*="Audio"] [class*="item"]',
        '#player [class*="track"] [class*="item"]',
        '#player [class*="sound"] button',
        '#player [class*="AudioTracks"] *'
      ];
      var out = [];
      var seen = {};
      for (var s = 0; s < sels.length; s++) {
        var nodes = document.querySelectorAll(sels[s]);
        for (var i = 0; i < nodes.length && out.length < 32; i++) {
          var txt = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
          if (!txt || txt.length > 64) continue;
          if (/^(auto|off|on|качество|субтитры|настройки)$/i.test(txt)) continue;
          if (seen[txt]) continue;
          seen[txt] = 1;
          out.push(txt);
        }
        if (out.length > 1) break;
      }
      if (out.length > 1) {
        window.__ksSoundList = out;
        return out;
      }
    } catch (e) {}
    return [];
  }

  function ensureSoundListFilled() {
    try {
      var s = findSettings();
      var player = window.__ksRawPlayer || findApp();
      hookSoundCapture(s, player);
      var fromSrc = readAudioListFromSource(player);
      if (fromSrc.length <= 1) {
        var fromPage = scrapeAudioNamesFromPage();
        if (fromPage.length > fromSrc.length) fromSrc = fromPage;
      }
      if (fromSrc.length <= 1) fromSrc = readAudioTracksFromVideo();
      if (fromSrc.length <= 1) fromSrc = scrapeSoundFromDom();
      var cached = window.__ksSoundList || [];
      var best = cached.length >= fromSrc.length ? cached : fromSrc;
      if (best.length <= 1) return best;
      // Push into Venom settings so ctrl.ls.sound / api.sound match UI list.
      // Rebind whenever our list is fuller than what Venom currently holds (often only "auto").
      if (s && typeof s.makeSound === 'function') {
        var cur = listFromCtrl(s.ctrl, 'sound');
        if (cur.length < best.length) {
          var idx = 0;
          try {
            var src = player && player.source;
            if (src && typeof src.defaultAudio === 'number' && src.defaultAudio >= 0) idx = src.defaultAudio;
          } catch (e) {}
          try {
            var curName = curFromCtrl(s.ctrl, 'sound');
            if (curName != null) {
              var prefer = best.indexOf(curName);
              if (prefer < 0) prefer = best.findIndex(function (x) { return String(x) === String(curName); });
              if (prefer >= 0) idx = prefer;
            }
          } catch (e) {}
          try {
            s.makeSound(best.slice(), function (i) {
              try {
                var p = window.__ksRawPlayer || findApp();
                if (p && p.source) p.source.audio = i;
              } catch (e2) {}
            }, idx);
          } catch (e) {}
        }
      }
      return best;
    } catch (e) { return window.__ksSoundList || []; }
  }

  function listFromCtrl(c, key) {
    try {
      var node = c && c.ls && c.ls[key];
      if (!node) return [];
      var v = (node.value !== undefined && node.value !== null) ? node.value : node;
      var out = coerceList(v);
      if (out.length) return out;
      // Nested Vue ref
      if (v && v.value !== undefined) out = coerceList(v.value);
      return out;
    } catch (e) { return []; }
  }

  function collectSoundList(s, c) {
    // Prefer captured full list from makeSound / audioList.
    try { ensureSoundListFilled(); } catch (e) {}
    if (window.__ksSoundList && window.__ksSoundList.length > 1) {
      return window.__ksSoundList.slice();
    }
    var list = [];
    try {
      if (s && s.sounds) list = normalizeList(s.sounds);
    } catch (e) {}
    if (!list.length) {
      try { if (s && s.soundList) list = normalizeList(s.soundList); } catch (e) {}
    }
    if (!list.length) {
      try { if (s && s.translations) list = normalizeList(s.translations); } catch (e) {}
    }
    if (!list.length && c) {
      list = listFromCtrl(c, 'sound');
      if (!list.length) list = listFromCtrl(c, 'voices');
      if (!list.length) list = listFromCtrl(c, 'audio');
      if (!list.length) list = listFromCtrl(c, 'translation');
    }
    if (!list.length) {
      try {
        var raw = window.__ksRawPlayer || findApp();
        list = readAudioListFromSource(raw);
      } catch (e) {}
    }
    if (!list.length || list.length <= 1) {
      var fromPage = scrapeAudioNamesFromPage();
      if (fromPage.length > list.length) list = fromPage;
    }
    if (!list.length) list = readAudioTracksFromVideo();
    if (!list.length) list = scrapeSoundFromDom();
    if (window.__ksSoundList && window.__ksSoundList.length > list.length) {
      list = window.__ksSoundList.slice();
    }
    // Map objects → display labels
    var mapped = [];
    for (var j = 0; j < list.length; j++) {
      var lab = labelOfSound(list[j]);
      mapped.push(lab != null ? lab : String(list[j]));
    }
    list = mapped;
    // Deduplicate
    var out = [];
    var seen = {};
    for (var n = 0; n < list.length; n++) {
      var it = list[n];
      var key = String(it);
      if (seen[key]) continue;
      seen[key] = 1;
      out.push(it);
    }
    if (out.length > 1) window.__ksSoundList = out;
    return out;
  }

  function curFromCtrl(c, key) {
    try {
      var v = c[key] && c[key].value;
      return v;
    } catch (e) { return null; }
  }

  function normalizeList(raw) {
    if (!raw) return [];
    try {
      if (Array.isArray(raw)) return raw.slice();
      if (typeof raw.length === 'number') return Array.prototype.slice.call(raw);
    } catch (e) {}
    return [];
  }

  function collectQualityList(s, c) {
    var list = [];
    try {
      if (s && s.qualities) list = normalizeList(s.qualities);
    } catch (e) {}
    if (!list.length) {
      try {
        if (s && s.qualityList) list = normalizeList(s.qualityList);
      } catch (e) {}
    }
    if (!list.length && c) list = listFromCtrl(c, 'quality');
    if (!list.length) {
      try {
        var raw = window.__ksRawPlayer;
        var hls = raw && raw.source && (raw.source.hls || raw.source.Hls);
        var levels = hls && (hls.levels || (hls.streamController && hls.streamController.levels));
        if (levels && levels.length) {
          for (var i = 0; i < levels.length; i++) {
            var lv = levels[i];
            var h = (lv && (lv.height || lv.attrs && lv.attrs.RESOLUTION && parseInt(String(lv.attrs.RESOLUTION).split('x')[1], 10))) || null;
            if (h) list.push(h);
            else if (lv && lv.bitrate) list.push(lv.bitrate);
          }
        }
      } catch (e) {}
    }
    // Deduplicate while preserving order
    var out = [];
    var seen = {};
    for (var j = 0; j < list.length; j++) {
      var item = list[j];
      var key = String(item);
      if (seen[key]) continue;
      seen[key] = 1;
      out.push(item);
    }
    return out;
  }

  function videoEl() {
    try {
      if (window.__ksRawPlayer && window.__ksRawPlayer.videoElement) return window.__ksRawPlayer.videoElement;
    } catch (e) {}
    try {
      var app = findApp();
      if (app && app.videoElement) return app.videoElement;
    } catch (e) {}
    try {
      var inPlayer = document.querySelector('#player video');
      if (inPlayer) return inPlayer;
    } catch (e) {}
    try {
      var nodes = document.querySelectorAll('video');
      for (var i = 0; i < nodes.length; i++) {
        try {
          if (nodes[i].getAttribute && nodes[i].getAttribute('data-ks-split') === '1') continue;
        } catch (e2) {}
        return nodes[i];
      }
    } catch (e3) {}
    return null;
  }

  function emptySettings() {
    return {
      quality: { list: [], current: null },
      sound: { list: [], current: null },
      cc: { list: [], current: null },
      skip: { list: [], current: null }
    };
  }

  function getSettings() {
    var base = emptySettings();
    var s = findSettings();
    var c = (s && s.ctrl) || getCtrl();
    if (!c) return base;
    try {
      var qualityList = collectQualityList(s, c);
      var soundList = collectSoundList(s, c);
      var ccList = listFromCtrl(c, 'cc');
      var skipList = listFromCtrl(c, 'skip');
      var qCur = (s && s.currentQuality != null && s.currentQuality !== undefined)
        ? s.currentQuality
        : curFromCtrl(c, 'quality');
      // If list is empty but current exists, still expose current as a single option
      // so the submenu is never blank while Venom is still filling ls.*.
      if (!qualityList.length && qCur != null && qCur !== undefined && qCur !== '-' && qCur !== '') {
        qualityList = [qCur];
      }
      var sCur = curFromCtrl(c, 'sound');
      if (sCur == null || sCur === undefined || sCur === '') {
        try { sCur = curFromCtrl(c, 'voices'); } catch (e) {}
      }
      if (!soundList.length && sCur != null && sCur !== undefined && sCur !== '') {
        soundList = [sCur];
      }
      var cCur = curFromCtrl(c, 'cc');
      if (!ccList.length && cCur != null && cCur !== undefined && cCur !== '') {
        ccList = [cCur];
      }
      return {
        quality: { list: qualityList, current: qCur },
        sound: { list: soundList, current: sCur },
        cc: { list: ccList, current: cCur },
        skip: { list: skipList, current: null }
      };
    } catch (e) {
      return base;
    }
  }

  function setSetting(kind, value) {
    var s = findSettings();
    try {
      if (s) {
        if (kind === 'quality' && typeof s.selectQuality === 'function') {
          s.selectQuality(value);
          return true;
        }
        if (kind === 'skip' && typeof s.toggleSkip === 'function') {
          s.toggleSkip(value, listFromCtrl(s.ctrl, 'skip'));
          return true;
        }
      }
    } catch (e) {}

    // Reactive ctrl: watches call the real api on the original settings object
    // even when we only hold the stripped facade `_settings.ctrl` copy.
    var c = (s && s.ctrl) || getCtrl();
    if (!c) return false;
    try {
      if (kind === 'sound') {
        try { repairBrokenMediaSrc(); } catch (eRep) {}
        // Menu shows studio names (audio.names). Venom ls.sound often has HLS labels (rus0…).
        // Resolve index against studio list, then switch by index — never by mismatched name.
        var studios = studioSoundNames();
        var idx = studios.indexOf(value);
        if (idx < 0) idx = studios.findIndex(function (x) { return String(x) === String(value); });
        if (idx < 0) {
          // Value might already be a Venom/HLS label — map via ctrl list or raw index.
          var ctrlSounds = listFromCtrl(c, 'sound');
          idx = ctrlSounds.indexOf(value);
          if (idx < 0) idx = ctrlSounds.findIndex(function (x) { return String(x) === String(value); });
        }
        if (idx < 0 && typeof value === 'number' && isFinite(value)) idx = value | 0;

        // Poke Venom api with a name it actually knows (before in-place switch).
        try {
          var venomNames = listFromCtrl(c, 'sound');
          if (idx >= 0 && venomNames && idx < venomNames.length && c && c.api && typeof c.api.sound === 'function') {
            try { c.api.sound(venomNames[idx]); } catch (eV1) {}
          } else if (c && c.api && typeof c.api.sound === 'function' && value != null) {
            try { c.api.sound(value); } catch (eV2) {}
          }
        } catch (eApi) {}

        // In-place only (hls.js / dash / native audioTracks). Never rewrites video.src.
        var switched = switchAudioByIndex(idx);
        try { persistTrackPreference((idx >= 0 && studios[idx] != null) ? studios[idx] : value, idx); } catch (ePers) {}
        dismissPlayerLoading();

        // Keep our chrome label on the studio name the user picked.
        try {
          if (c && c.sound) {
            c.sound.value = (idx >= 0 && studios[idx] != null) ? studios[idx] : value;
          }
        } catch (e3) {}
        return switched || idx >= 0;
      }
      if ((kind === 'quality' || kind === 'cc') && c[kind]) {
        if (c.api && typeof c.api[kind] === 'function') {
          try { c.api[kind](value); } catch (e) {}
        }
        c[kind].value = value;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function bind(app) {
    if (!app) return;
    try {
      // Never pin the Venom facade (no .source) as raw player.
      if (!window.__ksRawPlayer || !window.__ksRawPlayer.source) {
        if (app.source) window.__ksRawPlayer = app;
      }
    } catch (e) {}
    try { hookPlayerCapture(app); } catch (e) {}
    findSettings();
    try { ensureSoundListFilled(); } catch (e) {}
    try { findHlsMasterUrl(); } catch (e) {}
    try { cleanupSplitAudioArtifacts(); } catch (e) {}
    try { repairBrokenMediaSrc(); } catch (e) {}
    try { dismissPlayerLoading(); } catch (e) {}
    try { resolveCdnMasterUrl(); } catch (e) {}
    function kickFirstFrame(vid) {
      if (!vid) return;
      try { unhideVideoTree(); } catch (eU) {}
      try {
        if (vid.videoWidth > 0) return;
        if ((vid.__ksKickCount || 0) > 3) return;
        vid.__ksKickCount = (vid.__ksKickCount || 0) + 1;
        var t = 0;
        try { t = vid.currentTime || 0; } catch (eT) {}
        if (!isFinite(t) || t < 0) t = 0;
        forceTime(vid, t < 0.05 ? 0.05 : t);
      } catch (eK) {}
    }
    function setPlaying(want) {
      var play = !!want;
      var vid = videoEl();
      var p = window.__ksRawPlayer || app;
      try {
        var hls = p && p.source && p.source.hls;
        if (play && hls && typeof hls.startLoad === 'function') hls.startLoad();
      } catch (eH) {}
      if (vid) {
        try { if (play) vid.muted = false; } catch (eM) {}
        try {
          if (play) {
            var pr = vid.play();
            if (pr && pr.catch) pr.catch(function () {});
            try { vid.addEventListener('playing', function onPlayKick() {
              try { vid.removeEventListener('playing', onPlayKick); } catch (eR) {}
              kickFirstFrame(vid);
            }); } catch (eL) {}
            setTimeout(function () { kickFirstFrame(vid); }, 200);
            setTimeout(function () { kickFirstFrame(vid); }, 800);
          } else {
            vid.pause();
          }
        } catch (eV) {}
      }
      return true;
    }
    window.__kinoshka = {
      bridgeVersion: 28,
      seek: function (seconds) { return applySeek(window.__ksRawPlayer || app, seconds); },
      setPlaying: setPlaying,
      playPause: function () {
        var vid = videoEl();
        return setPlaying(!vid || !!vid.paused);
      },
      getSettings: getSettings,
      setSetting: setSetting,
      app: app
    };
    if (window.__kinoshkaBound) return;
    window.__kinoshkaBound = 1;
    post({ event: 'kinoshkaReady' });
    window.__ksWatchTimer = setInterval(function () {
      try { findSettings(); } catch (e) {}
      try { ensureSoundListFilled(); } catch (e) {}
      try { cleanupSplitAudioArtifacts(); } catch (e) {}
      try { repairBrokenMediaSrc(); } catch (e) {}
      try { dismissPlayerLoading(); } catch (e) {}
      try {
        var v = videoEl();
        if (v && isFinite(v.duration) && v.duration > 0) {
          post({
            event: 'viewProgress',
            time: v.currentTime || 0,
            duration: v.duration,
            paused: !!v.paused
          });
        }
      } catch (e) {}
    }, 500);
    addEventListener('message', function (e) {
      var d = e.data;
      if (!d || d.source !== 'kinoshka') return;
      try {
        var p = window.__ksRawPlayer || app;
        if (d.cmd === 'playPause') window.__kinoshka.playPause();
        else if (d.cmd === 'play') window.__kinoshka.setPlaying(true);
        else if (d.cmd === 'pause') window.__kinoshka.setPlaying(false);
        else if (d.cmd === 'seek' && typeof d.time === 'number') applySeek(p, d.time);
        else if (d.cmd === 'setSetting') setSetting(d.kind, d.value);
        else if (d.cmd === 'getSettings') post({ event: 'settings', settings: getSettings() });
      } catch (err) {}
    });
  }

  var n = 0;
  window.__ksBindTimer = setInterval(function () {
    if (window.app && (window.app.play || window.app._settings)) {
      clearInterval(window.__ksBindTimer);
      bind(window.app);
    }
    if (++n > 400) clearInterval(window.__ksBindTimer);
  }, 100);
})();
"""

    private fun jsStringLiteral(value: String): String = buildString(value.length + 2) {
        append('"')
        for (ch in value) {
            when (ch) {
                '\\' -> append("\\\\")
                '"' -> append("\\\"")
                '\n' -> append("\\n")
                '\r' -> append("\\r")
                '\t' -> append("\\t")
                else -> append(ch)
            }
        }
        append('"')
    }

    /**
     * JS that injects hide-CSS + bridge into the *current* document
     * (direct WebView navigation, not a nested iframe).
     * Always derived from [VENOM_HIDE_CSS] / [BRIDGE_SCRIPT_BODY] — never a stale copy.
     */
    fun injectIntoCurrentDocumentJs(): String {
        val cssLit = jsStringLiteral(VENOM_HIDE_CSS)
        val bridgeLit = jsStringLiteral(BRIDGE_SCRIPT_BODY)
        return buildString {
            append("(function(){")
            append("try{")
            append("var doc=document;")
            append("try{doc.documentElement.style.background='#000';}catch(e){}")
            append("try{if(doc.body)doc.body.style.background='#000';}catch(e){}")
            append("var style=doc.getElementById('kinoshka-hide-venom');")
            append("if(!style){style=doc.createElement('style');style.id='kinoshka-hide-venom';(doc.head||doc.documentElement||doc.body).appendChild(style);}")
            append("style.textContent=")
            append(cssLit)
            append(";")
            append("try{doc.documentElement&&doc.documentElement.classList.add('kinoshka-hide-venom');}catch(e){}")
            append("try{doc.body&&doc.body.classList.add('kinoshka-hide-venom');}catch(e){}")
            append("var nodes=doc.querySelectorAll('video');")
            append("for(var i=0;i<nodes.length;i++){try{nodes[i].controls=false;nodes[i].removeAttribute('controls');}catch(e){}}")
            append("}catch(e){}")
            append("try{")
            append("if(window.__kinoshka&&window.__kinoshka.bridgeVersion>=28)return'ok';")
            append("var existing=document.getElementById('kinoshka-bridge');")
            append("if(existing&&existing.parentNode)existing.parentNode.removeChild(existing);")
            append("try{window.__kinoshkaBridge=0;window.__kinoshkaBound=0;}catch(e){}")
            append("var s=document.createElement('script');s.id='kinoshka-bridge';s.text=")
            append(bridgeLit)
            append(";(document.head||document.documentElement||document.body).appendChild(s);")
            append("return'injected';")
            append("}catch(e){return'err:'+String(e);}")
            append("})();")
        }
    }

    /**
     * Restores a saved voice, quality and subtitle once those lists exist,
     * then lets the host read the choice that should be stored.
     * Safe to run again: a running restore keeps waiting, a finished one stays finished.
     */
    fun installPlaybackChoiceJs(audio: String?, quality: String?, subtitles: String?): String {
        val sound = jsStringLiteral(audio?.trim().orEmpty())
        val qualityLit = jsStringLiteral(quality?.trim().orEmpty())
        val cc = jsStringLiteral(subtitles?.trim().orEmpty())
        return """
(function(){
  var saved = { sound: $sound, quality: $qualityLit, cc: $cc };
  if (window.__ksChoice) {
    var prev = window.__ksChoice;
    if (prev.phase === 'user' || prev.phase === 'done') return 'exists';
    prev.saved = saved;
    if (prev.timer) return 'updated';
  }
  var ch = window.__ksChoice || { phase: 'wait', tries: 0, done: {}, last: '', timedOut: 0 };
  ch.saved = saved;
  ch.done = ch.done || {};
  window.__ksChoice = ch;
  function label(v) {
    if (v == null || v === undefined) return '';
    if (typeof v === 'object') v = v.title || v.name || v.label || v.type || '';
    var s = String(v);
    if (!s || s === 'null' || s === 'undefined' || s === '-') return '';
    return s;
  }
  function snap() {
    try { return window.__kinoshka && window.__kinoshka.getSettings && window.__kinoshka.getSettings(); }
    catch (e) { return null; }
  }
  function held(kind) {
    return window.__ksChoiceHold && window.__ksChoiceHold[kind];
  }
  function tryKind(kind) {
    if (held(kind)) { ch.done[kind] = 1; return; }
    var wanted = ch.saved && ch.saved[kind];
    if (!wanted) { ch.done[kind] = 1; return; }
    if (ch.done[kind]) return;
    var s = snap();
    var sec = s && s[kind];
    var list = sec && sec.list;
    if (!list || !list.length) return;
    var match = null;
    for (var i = 0; i < list.length; i++) {
      if (label(list[i]) === wanted || String(list[i]) === wanted) { match = list[i]; break; }
    }
    if (match == null) return;
    if (label(sec.current) === wanted) { ch.done[kind] = 1; return; }
    try { window.__kinoshka.setSetting(kind, match); } catch (e) {}
    ch.done[kind] = 1;
  }
  window.__ksChoiceUser = function(kind) {
    window.__ksChoiceHold = window.__ksChoiceHold || {};
    if (kind) window.__ksChoiceHold[kind] = 1;
    if (kind) ch.done[kind] = 1;
    ch.phase = 'user';
  };
  window.__ksChoiceReport = function() {
    if (ch.phase !== 'done' && ch.phase !== 'user') return null;
    var s = snap();
    if (!s) return null;
    function field(kind, key) {
      var value = label(s[kind] && s[kind].current);
      var wanted = ch.saved && ch.saved[key];
      if (held(kind)) return value;
      if (wanted && value !== wanted && !ch.done[kind]) return '';
      if (ch.timedOut && wanted && value !== wanted) return '';
      return value;
    }
    return { audio: field('sound', 'sound'), quality: field('quality', 'quality'), subtitles: field('cc', 'cc') };
  };
  window.__ksChoiceTake = function() {
    var r = window.__ksChoiceReport && window.__ksChoiceReport();
    if (!r) return null;
    var a = r.audio || '';
    var q = r.quality || '';
    var c = r.subtitles || '';
    if (!a && !q && !c) return null;
    var key = a + '\n' + q + '\n' + c;
    if (key === ch.last) return null;
    ch.last = key;
    return r;
  };
  if (ch.timer) return 'updated';
  ch.timer = setInterval(function() {
    ch.tries++;
    var current = ch.saved || {};
    var nothing = !current.sound && !current.quality && !current.cc;
    if (nothing) {
      var s = snap();
      var heard = label(s && s.sound && s.sound.current) || label(s && s.quality && s.quality.current) || label(s && s.cc && s.cc.current);
      if (heard) ch.phase = 'done';
      if (ch.phase === 'done' || ch.tries > 40) { clearInterval(ch.timer); ch.timer = 0; }
      return;
    }
    tryKind('sound');
    tryKind('quality');
    tryKind('cc');
    if ((ch.done.sound && ch.done.quality && ch.done.cc) || ch.tries > 40) {
      if (!(ch.done.sound && ch.done.quality && ch.done.cc)) ch.timedOut = 1;
      ch.phase = 'done';
      clearInterval(ch.timer);
      ch.timer = 0;
    }
  }, 400);
  return 'installed';
})();
""".trimIndent()
    }
}
